import { useEffect, useState } from "react";

interface UndoToastProps {
  title: string;
  deadlineMs: number;
  pending: boolean;
  onUndo: () => void;
  onExpire: () => void;
}

export function UndoToast({
  title,
  deadlineMs,
  pending,
  onUndo,
  onExpire,
}: UndoToastProps) {
  const [remaining, setRemaining] = useState(() => secondsRemaining(deadlineMs));

  useEffect(() => {
    const update = () => {
      const next = secondsRemaining(deadlineMs);
      setRemaining(next);
      if (next === 0) onExpire();
    };
    update();
    const timer = window.setInterval(update, 250);
    return () => window.clearInterval(timer);
  }, [deadlineMs, onExpire]);

  return (
    <div className="undo-toast" role="status" aria-live="polite">
      <span className="undo-check" aria-hidden="true">✓</span>
      <span className="undo-message">已完成「{title}」</span>
      <button
        type="button"
        className="undo-button"
        disabled={pending || remaining === 0}
        onClick={onUndo}
        aria-label={`復原「${title}」`}
      >
        {pending ? "復原中" : `復原 ${remaining}`}
      </button>
    </div>
  );
}

function secondsRemaining(deadlineMs: number) {
  return Math.max(0, Math.ceil((deadlineMs - Date.now()) / 1_000));
}
